define('modules/search_field/search_field_view',[
  'backbone',
  'jquery',
  '_',

  'text!./search_field_template.html'
], function (Backbone, $, _,
             template) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function (opts) {
      _.extend(this, opts);

      this.searchQuery = (this.collection && this.collection.params.search) ? this.collection.params.search : '';
      this.render();
    },

    tagName: 'div',
    className: 'search-field',

    template: _.template(template),

    events: {
      'click .js-search-field': 'expand',
      'click .js-search-field-clear': 'clearSearch',
      'keydown .js-search-field-input': 'inputKeydown',
      'keyup .js-search-field-input': 'inputKeyup'
    },

    render: function () {
      this.$el.html(this.template({query: this.searchQuery}));
      return this;
    },

    expand: function (e) {
      e.preventDefault();

      if (this.$('.js-search-field-input').hasClass('expanded')) {
        this.search(this.$('.js-search-field-input').val());
      } else {
        this.$('.js-search-field-input').addClass('expanded').focus();
      }
    },

    inputKeydown: function (e) {
      var searchPhrase;

      if (e.keyCode === 13) {
        searchPhrase = e.currentTarget.value;
        this.search(searchPhrase);
        return false;
      }
    },

    inputKeyup: function (e) {
      var searchPhrase = e.currentTarget.value;

      if (searchPhrase === '') {
        //If searchPhrase is empty after user has pressed backspace or delete
        //keyCode 8 = backspace, keyCode 46 = delete
        if (e.keyCode === 8 || e.keyCode === 46) {
          this.clearSearch();
        }
      }

    },

    search: function (searchPhrase) {

      if (!this.collection) {
        throw new Error('Collection required');
      }

      this.collection.params = _.extend(this.collection.params, {
        search: searchPhrase,
        offset: 0
      });

      this.collection.fetch();
    },

    clearSearch: function () {
      this.$('.js-search-field-clear').hide();
      this.$('.js-search-field-input').val('');
      this.search(null);
    },

    remove: function () {
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    }
  });

  return View;
});

